import { API_URL } from '../constants';

export const CURRENT_INVENTORY_DROPDOWN = `${API_URL}/v1/current_inventory_dropdown`;
